import { Box, styled } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { PropsWithChildren } from 'react';

const StyledHeader = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    '& h2': {
        fontSize: 20,
    },
}));

export const SectionHeader = (props: PropsWithChildren) => {
    return (
        <StyledHeader>
            <PoolTypography styleType="sectionTitle" color="inherit">
                {props.children}
            </PoolTypography>
        </StyledHeader>
    );
};
